import { render } from "./TaskManager.vue?vue&type=template&id=f327fa72&lang=pug"
import script from "./TaskManager.vue?vue&type=script&lang=js"
export * from "./TaskManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/topBar/TaskManager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f327fa72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f327fa72', __exports__)) {
    api.reload('f327fa72', __exports__)
  }
  
  module.hot.accept("./TaskManager.vue?vue&type=template&id=f327fa72&lang=pug", () => {
    api.rerender('f327fa72', render)
  })

}


export default __exports__